import React, { useEffect } from 'react'
import { verify } from 'jsonwebtoken'
import { useDispatch } from 'react-redux'
import { Spin } from 'antd'
import { actionCreators } from '@/duck/user'

import '@/components/Profile.less'

const Profile = ({ location, history }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        const { search } = location
        if (!search) {
            history.push('/channel/index')
            return
        }
        const token = new URLSearchParams(search).get('token')
        const { user } = verify(token, 'secret')
        dispatch(actionCreators.user.update({ user }))
        history.push('/')
    }, [dispatch, history, location])
    return (
        <div className="profile-container">
            <Spin size="large" />
        </div>
    )
}

export default Profile